// Get the current pathname
export const getPathname = (state) => state.router.location.pathname;
